module.exports = __webpack_public_path__ + "img/e44.b40fa662.png";